import style from "./Chip.module.scss";
import cn from "classnames";

export function Chip({
    color = "green",
    size = "small",
    variant = "filled",
    icon,
    aligtIcon = "right",
    text
}: {
    color?: "green" | "red" | "blue" | "orange" | "purple",
    size?: "small" | "middle" | "big",
    variant?: "filled" | "outline",
    icon?: JSX.Element,
    aligtIcon?: "left" | "right",
    text: string
}) {
    return (
        <div className={cn(
            style.chip,
            style["color_" + color],
            style["size_" + size],
            style["variant_" + variant],
            style["aligtIcon_" + aligtIcon],
            icon ? "justify-between" : "justify-center"
        )}>
            <p className={style.text}>{text}</p>
            {icon}
        </div>
    )
}